import { DAYS_OF_WEEK } from '../constants';

export const getDayLabel = (day: number) => {
  const dayObj = DAYS_OF_WEEK.find((d) => d.value === day);
  if (!dayObj) {
    throw new Error(`Invalid day value: ${day}`);
  }
  return dayObj.label;
};

export const parsePaddleDate = (dateString: string): Date => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    throw new Error(`Invalid date string: ${dateString}`);
  }
  return date;
};
